"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = bindActions;
const types_1 = __importDefault(require("./types"));
function updateCartPriceDiscountAction(state, discountKey, qualifies) {
    const { cartPriceDiscounts
    // cartPriceDiscountTotal // TODO: will need per explanation below
     } = state;
    const newCartPriceDiscounts = cartPriceDiscounts;
    newCartPriceDiscounts[discountKey].qualifies = qualifies;
    const modifier = qualifies ? 1 : 0;
    // TODO: when all value discounts are moved to cart price rules, update to account for more than one active "cart price rule discount"
    const newDiscountTotal = (modifier * cartPriceDiscounts[discountKey].discountValue); // hotfix for quic mrc implementation + cartPriceDiscountTotal
    return { newDiscountTotal, newCartPriceDiscounts };
}
function UpdateCartPriceDiscount(discountKey, qualifies) {
    this.dispatch({ type: types_1.default.UPDATE_CART_PRICE_DISCOUNTS, payload: [updateCartPriceDiscountAction, [discountKey, qualifies]] });
}
function bindActions(dispatch) {
    return {
        UpdateCartPriceDiscount: UpdateCartPriceDiscount.bind({ dispatch }),
        promotionsDispatch: dispatch
    };
}
//# sourceMappingURL=actions.js.map